import { Chip } from "@mui/material";
import {
  CheckCircle,
  ErrorOutline,
  HourglassEmpty,
  RemoveCircleOutline,
} from "@mui/icons-material";

export type ValidationStatus =
  | { kind: "empty" }
  | { kind: "checking" }
  | { kind: "ok" }
  | { kind: "error"; message: string };

interface Props {
  status: ValidationStatus;
  // Per-step copy. The filter and search steps share the chip's shape,
  // colors, and icons but disagree on what to call themselves.
  emptyLabel: string;
  okLabel: string;
  errorPrefix: string;
}

export function ValidationStatusChip({ status, emptyLabel, okLabel, errorPrefix }: Props) {
  switch (status.kind) {
    case "empty":
      return (
        <Chip size="small" variant="outlined" icon={<RemoveCircleOutline />} label={emptyLabel} />
      );
    case "checking":
      return (
        <Chip size="small" variant="outlined" icon={<HourglassEmpty />} label="Checking…" />
      );
    case "ok":
      return <Chip size="small" color="success" icon={<CheckCircle />} label={okLabel} />;
    case "error":
      return (
        <Chip
          size="small"
          color="error"
          icon={<ErrorOutline />}
          label={`${errorPrefix}: ${status.message}`}
          // Long error messages from the parser shouldn't blow up the layout —
          // let the chip wrap text rather than overflow.
          sx={{
            maxWidth: "100%",
            "& .MuiChip-label": {
              whiteSpace: "normal",
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            height: "auto",
            py: 0.5,
          }}
        />
      );
  }
}
